import React from "react";
import { Menu } from "primereact/menu";
import PropTypes from "prop-types";
import { useNavigate, useLocation } from "react-router-dom";
import "./SideBar.css"; // Create a separate CSS file for SideBar styles

const SideBar = ({ items }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // console.log("items", items);

  const isNavBarPath =
    location.pathname.split("/").filter(Boolean).length === 1;
  // console.log("isNavBarPath", isNavBarPath);

  const menuItems = items.map((item, idx) => {
    // If current path is a navbar path (e.g., "/something"), highlight the first item
    const pathSegments = location.pathname.split("/").filter(Boolean);
    // console.log("pathSegments", pathSegments);
    const secondSegment = pathSegments[1] || "";
    // console.log("secondSegment", secondSegment);
    const itemLastSegment = item.path.split("/").filter(Boolean).pop() || "";
    // console.log("item.path", item.path);
    // console.log("itemLastSegment", itemLastSegment);

    const isSelected =
      (isNavBarPath && idx === 0) ||
      (!isNavBarPath && item.path !== "/" && secondSegment === itemLastSegment);

    return {
      ...item,
      className: isSelected ? "p-menuitem p-focus" : "p-menuitem",
      command: () => navigate(item.path),
    };
  });

  return <Menu model={menuItems} className="sidebar-menu" />;
};

SideBar.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.string,
      path: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default SideBar;
